import React from 'react';
import { renderEstadoBadge } from '../../utils/cotizacionHelpers';

/**
 * Timeline de revisiones de la cotización.
 *
 * @param {Object} props
 * @param {Array} props.revisiones - Lista de revisiones
 * @param {number} props.cotizacionActualId - ID de la cotización actual
 * @param {Function} props.onVerRevision - Handler para navegar a una revisión
 * @returns {JSX.Element|null}
 */
function CotizacionRevisiones({ revisiones, cotizacionActualId, onVerRevision }) {
  if (revisiones.length <= 1) return null;

  return (
    <div className="card">
      <h2 style={{ marginBottom: 'var(--space-lg)' }}>
        <i className="fas fa-history"></i> Historial de Revisiones
      </h2>

      <div className="revision-timeline">
        {revisiones.map((rev, index) => (
          <div key={rev.id} className={`timeline-item ${rev.id === cotizacionActualId ? 'timeline-item--active' : ''}`}>
            <div className="timeline-connector">
              <div className="timeline-dot"></div>
              {index < revisiones.length - 1 && <div className="timeline-line"></div>}
            </div>

            <div
              className={`timeline-content ${rev.id !== cotizacionActualId ? 'cursor-pointer' : 'cursor-default'}`}
              onClick={() => rev.id !== cotizacionActualId && onVerRevision(rev.id)}
            >
              <div className="timeline-header">
                <strong style={{ fontSize: 'var(--font-size-lg)' }}>Revisión {rev.revision}</strong>
                {renderEstadoBadge(rev.estado)}
                {rev.id === cotizacionActualId && (
                  <span className="badge badge-success"><i className="fas fa-check-circle"></i> Actual</span>
                )}
              </div>

              <div className="timeline-meta text-muted text-sm margin-top-xs">
                <span><i className="fas fa-calendar"></i> {new Date(rev.fecha_emision).toLocaleDateString('es-CL')}</span>
                <span className="timeline-separator">•</span>
                <span><i className="fas fa-dollar-sign"></i> ${parseFloat(rev.total).toLocaleString('es-CL')}</span>
                <span className="timeline-separator">•</span>
                <span><i className="fas fa-list"></i> {rev.total_items} items</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default CotizacionRevisiones;
